import React, { useEffect, useState } from "react";
import { generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels } from "./../../utils";
import { proxy } from '../../process/api';
import ReportOptions from "../ReportOptions";
import PasswordStrengthBar from 'react-password-strength-bar';
import {getUserID} from "../../utils";
import { useNavigate } from "react-router-dom";

const TL01 = () => {

    const [pageTitle, setPageTitle] = useState('');
    const [loginErrorMessage, setLoginErrorMsg] = useState('');
    const currentToken = localStorage.getItem('token');
    const [isValid, setIsValid] = useState(true);
    const [confPassword, setConfPassword] = useState('');
    const [password, setPassword] = useState('');
    const [oldPassword, setoldPassword] = useState('');
    const [isLoginError, setLoginError] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);

   
    const navigate = useNavigate();

    const handleChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        validatePassword(newPassword);
    };

    const validatePassword = (password) => {
        return true;
        const minLength = password.length >= 8;
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        
        setIsValid(minLength && hasNumber && hasSpecialChar);
      };



      const handleSubmit = async (event) => {
        if(password != confPassword){
            alert("Password and Confirm password should be same.");
            return;
        }
        if(password == ""){
            alert("Password cannot be empty.");
            return;
        }
        if(password == "123" || password == "1234" ){
            alert("This password is not allowed.");
            return;
        }
        
        event.preventDefault();

        var btnLogin = document.getElementById('btnReportGen');
        btnLogin.innerText = 'Processing...';
       
        const payload = {
            "user_id":getUserID(currentToken),
    "old_password":oldPassword,
    "new_password":confPassword
        }
        const apiResponse =  await proxy(`/auth/changePassword`, payload, "post");
      alert(apiResponse);
      
        if(apiResponse == "Password Changes successfully"){
            setLoginErrorMsg(apiResponse);
            setisSuccess(true);
    
            setConfPassword('');
            setPassword('');
            setoldPassword('');
            var btnLogin = document.getElementById('btnReportGen');
            btnLogin.innerText = 'Change Password';
          
            
        }else{
            setLoginErrorMsg(apiResponse);
            setLoginError(true);
    
            setConfPassword('');
            setPassword('');
            setoldPassword('');
            var btnLogin = document.getElementById('btnReportGen');
            btnLogin.innerText = 'Change Password';
        }

    };



    useEffect(() => {

        transformNavDataForLabels("TL02").then(title => {
            setPageTitle(title);
        });

    }, []);

    return (
        <>
            <div class="main-content">

                <ReportOptions title={pageTitle} >
                    <div className="report-option-wrapper">
                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label style={{minWidth:"140px"}}>Current&nbsp;Password</label>
                                <input  className="form-control" type="password" style={{minWidth:"300px"}} 
                                
                                id="oldPass"
                                value={oldPassword}
                                onChange={(e)=>setoldPassword(e.target.value)}
                                
                                />
                            </div>




                        </div>
                        <div className="report-option-row">
                            <div className="report-option-item" style={{alignItems:"flex-start"}}>
                                <label style={{minWidth:"140px"}}>New&nbsp;Password</label>
                                <div>
                                <input  className="form-control" type="password" 
                                
                                id="username"
                                value={password}
                                onChange={(e) => handleChange(e)}
                                style={{ borderColor: isValid ? 'transparent' : 'red',outline:isValid ? 'initial' : 'red',minWidth:"300px" }}/>


                           
                               
                            <PasswordStrengthBar password={password} minLength={8} />

</div>
                          </div >
                           
                   

                        </div>

                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label style={{minWidth:"140px"}}>Confirm&nbsp;Password</label>
                                <input  className="form-control" type="password" style={{minWidth:"300px"}}
                                
                                id="confpassword"
                                value={confPassword}
                                onChange={(e)=>setConfPassword(e.target.value)}
                                />
                            </div>




                        </div>

                        <div className="report-option-action-row">
                            <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                            <button onClick={handleSubmit}  className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >CHANGE PASSWORD</button>
                        </div>






                    </div>

                </ReportOptions>
            </div>
        </>
    );
}

export default TL01;